module.exports = __webpack_public_path__ + "02_glasses_black.b55de6a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/02_glasses_black.png
// module id = BiOd
// module chunks = 0